import { currentWorkspaceId } from "index";

export const getterApis = {
	GET_ACCOUNT_IMG: (sessionId, refreshValue) => `api/settings/getAccountImage?sid=${sessionId}&${refreshValue}&workspaceId=${currentWorkspaceId}`,
	GET_MAP_CUSTOM_IMG: (cjmIdStr, sessionId) => `api/map/getCustomImage?cjmIdStr=${cjmIdStr}&sid=${sessionId}&workspaceId=${currentWorkspaceId}`,
	GET_CUSTOM_ICON: (iconIdStr, sessionId) => `api/icon/getCustomImage?iconIdStr=${iconIdStr}&sid=${sessionId}&workspaceId=${currentWorkspaceId}`,
	GET_CX_PROGRAM_IMG: (cxProgramId, sessionId) => `api/cxProgram/getCustomImage?cxProgramId=${cxProgramId}&sid=${sessionId}&workspaceId=${currentWorkspaceId}`,
};
